import BankSlipCopyPage from './BankSlipCopyPage';

export default BankSlipCopyPage;
